<ng-content select="[slot=start]" />
<div class="ds-card-header-text">
    <div class="ds-card-header-title-wrapper">
        @if (title()) {
            <span class="ds-card-header-title" [class.ds-card-header-title-expand]="!subtitle()">{{ title() }}</span>
        }
        <ng-content select="[slot=title]" />
    </div>
    @if (subtitle()) {
        <span class="ds-card-header-subtitle">{{ subtitle() }}</span>
    }
</div>
<div class="ds-card-header-slot-container">
    <ng-content select="[slot=end]" />
</div>
